import React from "react";
import { useTranslation } from "react-i18next";
import { MenuItem, Select } from "@mui/material";
import { ValuationType } from "common/types/common.types";
import { ValuationTypeFilter as ValuationTypeFilterType } from "../../types/api.types";

interface ValuationTypeFilterProps {
  value: ValuationTypeFilterType;
  onChange: (value: ValuationTypeFilterType) => void;
  width?: string;
  maxWidth?: string;
}

export const ValuationTypeFilter: React.FC<ValuationTypeFilterProps> = ({
  value,
  onChange,
  width = "300px",
  maxWidth = "400px",
}) => {
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth }}>
      <div style={{ marginBottom: "15px" }}>
        {t("valuationsStatistics.valuationTypeFilter")}
      </div>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value as ValuationTypeFilterType)}
        style={{ width }}
      >
        <MenuItem value="all">{t("valuationsStatistics.all")}</MenuItem>
        <MenuItem value={ValuationType.FullReport}>
          {t("propertyForm.valuationType.fullReport.title")}
        </MenuItem>
        <MenuItem value={ValuationType.PriceCheck}>
          {t("propertyForm.valuationType.priceCheck.title")}
        </MenuItem>
        <MenuItem value={ValuationType.LocationCheck}>
          {t("propertyForm.valuationType.locationCheck.title")}
        </MenuItem>
      </Select>
    </div>
  );
};
